import * as React from 'react'
import cc from 'classcat'
import Link from 'gatsby-link'
import Image from 'gatsby-image'
import BurgerMenu from '../BurgerMenu'
import Header from '../Header'
import LanguageDropdown from '../LanguageDropdown'

import s from './styles.module.css'

const NavLink = ({ to, children }) => (
  <Link to={to} className={cc([s.link, s.desktopMenuItem])}>
    {children}{' '}
  </Link>
)

export default class Navigation extends React.Component {
  render() {
    const { locale, onLocaleChange, logo } = this.props
    const homePath = `/${locale === 'en' ? '' : locale}`

    return (
      <div className={s.wrapper}>
        <Header
          className={s.header}
          languageDropdownClassName={s.languageDropdown}
          locale={locale}
          onLocaleChange={onLocaleChange}
        />
        <nav className={s.navigation}>
          <NavLink to={`/${locale}/restaurant`}>Restaurant</NavLink>
          <NavLink to={`/${locale}/accommodation`}>Accommodation</NavLink>
          <Link to={homePath}>
            <Image
              className={s.logo}
              sizes={logo.sizes}
              alt="Augusta Insula Lastovo"
            />
          </Link>
          <NavLink to={`/${locale}/docking`}>Docking</NavLink>
          <NavLink to={`/${locale}/tours`}>Adventure Tours</NavLink>
        </nav>

        <BurgerMenu buttonClassName={s.burger}>
          <Link className={cc([s.link, s.burgerLink])} to={homePath}>
            Home
          </Link>
          <Link
            className={cc([s.link, s.burgerLink])}
            to={`/${locale}/restaurant`}
          >
            Restaurant
          </Link>
          <Link
            className={cc([s.link, s.burgerLink])}
            to={`/${locale}/accommodation`}
          >
            Accommodation
          </Link>
          <Link
            className={cc([s.link, s.burgerLink])}
            to={`/${locale}/docking`}
          >
            Docking
          </Link>
          <Link className={cc([s.link, s.burgerLink])} to={`/${locale}/tours`}>
            Adventure Tours
          </Link>
          <Link
            className={cc([s.link, s.burgerLink])}
            to={`/${locale}/contact`}
          >
            How to find us
          </Link>
          <LanguageDropdown
            triggerClassName={s.languageDropdownTrigger}
            dropdownClassName={s.languageDropdown}
            className={s.burgerLanguageDropdown}
            caretClassName={s.languageDropdownCaret}
            locale={locale}
            onLocaleChange={onLocaleChange}
          />
        </BurgerMenu>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js